export default __webpack_public_path__ + "static/media/alertIconPink.7fd351f6.svg";